<template>
    <div>
        <v-container v-if="detail.proposal_is_compatible" class="pt-0 pb-0">
            <v-row v-if="detail.agreement_id !== null " class="agreement_line_item text-subtitle-1 font-weight-regular text-left" align="center">
                <v-col cols=5 xl=5 class="pt-0 pb-0 pr-lg-0 pl-lg-1 pr-xl-2 pl-xl-2">
                    Agreement Actions:
                </v-col>
                <v-col cols=2 class="pt-0 pb-0">
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            fab 
                            small
                            color="grey lighten-2"
                            class="mx-2"
                            v-on="on"
                            elevation=0
                            @click="editAgreement(detail.agreement_id)"
                          >
                            <v-icon color="amber darken-2" large>mdi-pencil-outline</v-icon>
                          </v-btn>
                        </template>
                        <span><span><v-icon color="amber darken-2">mdi-alert-circle-outline</v-icon>Coming Soon! </span>Edit Rapid Agreement</span>
                    </v-tooltip>
                </v-col>
                <v-col cols=3 class="pt-2 pb-2">
                    <AgreementQueue :detail=detail :id=detail.agreement_id :status=detail.agreement_pdf />
                </v-col>
                <v-col cols=2 class="pt-0 pb-0">
                    <v-dialog
                    v-model="confirm"
                    :retain-focus="false"
                    persistent
                    max-width="290px"
                    >
                        <template v-slot:activator="{ on: confirm, attrs }">
                            <v-tooltip top>
                                <template v-slot:activator="{ on: tooltip }">
                                  <v-btn
                                    fab 
                                    small
                                    color="grey lighten-2"
                                    class="mx-2"
                                    elevation=0
                                    v-bind="attrs"
                                    v-on="{ ...tooltip, ...confirm }"
                                  >
                                    <v-icon color="red" large>mdi-delete</v-icon>
                                  </v-btn>
                                </template>
                                <span>Delete Rapid Agreement</span>
                            </v-tooltip>
                        </template>
                        <v-card>
                            <v-card-title><span class='ml-12'>Confirm Delete</span></v-card-title>
                            <v-card-text>
                                Are you sure? This can not be undone.
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                color="primary"
                                @click="deleteAgreement(detail.agreement_id)"
                                >
                                    Confirm
                                </v-btn>
                                <v-spacer></v-spacer>
                                <v-btn
                                depressed
                                @click="confirm = false">
                                    Cancel
                                </v-btn>
                                <v-spacer></v-spacer>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-col>
            </v-row>
            <v-row v-else class="agreement_line_item text-subtitle-1 font-weight-regular text-left" align="center">
                <v-col cols=7 xl=7 class="pt-0 pb-0">
                    Add Rapid Agreement:
                </v-col>
                <v-col cols=2 offset-lg=3 offset-xl=3 class="pt-0 pb-0">
                   <v-dialog
                   v-model="dialog"
                    persistent
                    max-width="900px"
                   >
                      <template v-slot:activator="{ on: dialog, attrs }">
                        <v-tooltip top>
                          <template v-slot:activator="{ on: tooltip }">
                            <v-btn
                              fab
                              small
                              color="grey lighten-2"
                              class="mx-2"
                              elevation=0
                              v-bind="attrs"
                              v-on="{ ...tooltip, ...dialog }"
                              @click=getClientObj
                            >
                              <v-icon color="primary">mdi-plus</v-icon>
                            </v-btn>
                          </template>
                          <span>Generate Rapid Agreement</span>
                        </v-tooltip>
                      </template>
                      <v-card>
                            <v-card-text>
                                <v-container>
                                  <div class="text-h4 font-weight-regular primary--text text-center">Rapid Agreement</div>
                                </v-container>
                                <v-container>
                                    <v-row>
                                        <v-col cols=12 sm=4 md=4>
                                            <v-text-field 
                                            outlined
                                            v-model="planName"
                                            label="Plan Name"
                                            >    
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols=12 sm=4 md=4>
                                            <v-text-field 
                                            outlined
                                            v-mask="'####-##-##'"
                                            v-model="planYearBegin"
                                            label="Plan Year Begin (YYYY-MM-DD)"
                                            >    
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols=12 sm=4 md=4>
                                            <v-text-field 
                                            outlined
                                            v-mask="'####-##-##'"
                                            v-model="planYearEnd"
                                            label="Plan Year End (YYYY-MM-DD)"
                                            >    
                                            </v-text-field>
                                        </v-col>
                                     </v-row>
                                    <v-row>
                                         <v-col cols=12 sm=6 md=6>
                                            <v-text-field 
                                            outlined
                                            v-model="sponsor_first_name"
                                            label="Sponsor First Name"
                                            >    
                                            </v-text-field>
                                        </v-col>
                                         <v-col cols=12 sm=6 md=6>
                                            <v-text-field 
                                            outlined
                                            v-model="sponsor_last_name"
                                            label="Sponsor Last Name"
                                            >    
                                            </v-text-field>
                                        </v-col>
                                     </v-row>
                                    <v-row>
                                         <v-col cols=12 sm=6 md=12>
                                            <v-text-field 
                                            outlined
                                            v-model="sponsor_email"
                                            label="Sponsor Email"
                                            >    
                                            </v-text-field>
                                        </v-col>
                                         <v-col cols=12 sm=6 md=12>
                                            <v-text-field 
                                            outlined
                                            v-model="sponsor_address"
                                            label="Sponsor Address"
                                            >    
                                            </v-text-field>
                                        </v-col>
                                         <v-col cols=12 sm=6 md=6>
                                            <v-text-field 
                                            outlined
                                            v-model="sponsor_zip"
                                            label="Sponsor Zipcode"
                                            >    
                                            </v-text-field>
                                        </v-col>
                                         <v-col cols=12 sm=6 md=6>
                                            <v-text-field 
                                            outlined
                                            v-model="sponsor_city"
                                            label="Sponsor City"
                                            >    
                                            </v-text-field>
                                        </v-col>
                                         <v-col cols=12 sm=6 md=6>
                                            <v-text-field 
                                            outlined
                                            v-model="sponsor_state"
                                            label="Sponsor State"
                                            >    
                                            </v-text-field>
                                        </v-col>
                                         <v-col cols=12 sm=6 md=6>
                                            <v-text-field 
                                            outlined
                                            v-mask="'(###) ###-####'"
                                            v-model="sponsor_phone"
                                            label="Sponsor Phone"
                                            >    
                                            </v-text-field>
                                        </v-col>
                                         <v-col cols=12 sm=6 md=6>
                                            <v-text-field 
                                            outlined
                                            v-mask="'(###) ###-####'"
                                            v-model="sponsor_fax"
                                            label="Sponsor Fax"
                                            >    
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols=12 sm=6 md=6>
                                            <v-text-field 
                                            outlined
                                            v-model="sponsor_ein"
                                            label="Sponsor EIN"
                                            >    
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols=12 sm=6 md=6>
                                            <v-autocomplete
                                                v-model="template_selected"
                                                label="Select A Template"
                                                :items=agreementTemplateList
                                                item-text="template_name"
                                                item-value="template_id"
                                                outlined
                                                return-object
                                                hide-details
                                            >
                                            </v-autocomplete>
                                        </v-col>
                                     </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                color="primary"
                                text
                                @click="dialog = false"
                              >
                                Close
                              </v-btn>
                              <v-btn
                                color="primary"
                                text
                                @click="addAgreement(detail)"
                              >
                                Create Agreement
                              </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-col>
            </v-row>
        </v-container>
        <v-container v-else class="pt-0 pb-0">
            <v-row class="agreement_line_item text-subtitle-1 font-weight-regular text-left" align="center">
                <v-col cols=7 xl=7 class="pt-0 pb-0">
                    Add Rapid Agreement:
                </v-col>
                <v-col cols=2 offset-lg=3 offset-xl=3 class="pt-0 pb-0">
                   <v-dialog
                   v-model="dialog"
                    persistent
                    max-width="900px"
                   >
                      <template v-slot:activator="{ on: dialog, attrs }">
                        <v-tooltip top>
                          <template v-slot:activator="{ on: tooltip }">
                            <v-btn
                              fab
                              small
                              color="grey lighten-2"
                              class="mx-2"
                              elevation=0
                              v-bind="attrs"
                              v-on="{ ...tooltip, ...dialog }"
                            >
                              <v-icon color="amber darken-2">mdi-alert-circle-outline</v-icon>
                            </v-btn>
                          </template>
                          <span>This proposal is not compatible with
                          <br>the current version of Rapid Quote.
                          <br>Please generate a new proposal before
                          <br>creating an agreement.
                          </span>
                        </v-tooltip>
                      </template>
                      <v-card>
                            <v-card-text>
                                <v-container>
                                  <div class="text-h4 font-weight-regular primary--text text-center">Rapid Agreement</div>
                                </v-container>
                                <v-container>
                                    <v-row>
                                        <v-col cols=12 sm=4 md=4>
                                            <v-text-field 
                                            outlined
                                            v-model="planName"
                                            label="Plan Name"
                                            >    
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols=12 sm=4 md=4>
                                            <v-text-field 
                                            outlined
                                            v-mask="'####-##-##'"
                                            v-model="planYearBegin"
                                            label="Plan Year Begin (YYYY-MM-DD)"
                                            >    
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols=12 sm=4 md=4>
                                            <v-text-field 
                                            outlined
                                            v-mask="'####-##-##'"
                                            v-model="planYearEnd"
                                            label="Plan Year End (YYYY-MM-DD)"
                                            >    
                                            </v-text-field>
                                        </v-col>
                                     </v-row>
                                    <v-row>
                                         <v-col cols=12 sm=6 md=6>
                                            <v-text-field 
                                            outlined
                                            v-model="sponsor_first_name"
                                            label="Sponsor First Name"
                                            >    
                                            </v-text-field>
                                        </v-col>
                                         <v-col cols=12 sm=6 md=6>
                                            <v-text-field 
                                            outlined
                                            v-model="sponsor_last_name"
                                            label="Sponsor Last Name"
                                            >    
                                            </v-text-field>
                                        </v-col>
                                     </v-row>
                                    <v-row>
                                         <v-col cols=12 sm=6 md=12>
                                            <v-text-field 
                                            outlined
                                            v-model="sponsor_email"
                                            label="Sponsor Email"
                                            >    
                                            </v-text-field>
                                        </v-col>
                                         <v-col cols=12 sm=6 md=12>
                                            <v-text-field 
                                            outlined
                                            v-model="sponsor_address"
                                            label="Sponsor Address"
                                            >    
                                            </v-text-field>
                                        </v-col>
                                         <v-col cols=12 sm=6 md=6>
                                            <v-text-field 
                                            outlined
                                            v-model="sponsor_zip"
                                            label="Sponsor Zipcode"
                                            >    
                                            </v-text-field>
                                        </v-col>
                                         <v-col cols=12 sm=6 md=6>
                                            <v-text-field 
                                            outlined
                                            v-model="sponsor_city"
                                            label="Sponsor City"
                                            >    
                                            </v-text-field>
                                        </v-col>
                                         <v-col cols=12 sm=6 md=6>
                                            <v-text-field 
                                            outlined
                                            v-model="sponsor_state"
                                            label="Sponsor State"
                                            >    
                                            </v-text-field>
                                        </v-col>
                                         <v-col cols=12 sm=6 md=6>
                                            <v-text-field 
                                            outlined
                                            v-mask="'(###) ###-####'"
                                            v-model="sponsor_phone"
                                            label="Sponsor Phone"
                                            >    
                                            </v-text-field>
                                        </v-col>
                                         <v-col cols=12 sm=6 md=6>
                                            <v-text-field 
                                            outlined
                                            v-mask="'(###) ###-####'"
                                            v-model="sponsor_fax"
                                            label="Sponsor Fax"
                                            >    
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols=12 sm=6 md=6>
                                            <v-text-field 
                                            outlined
                                            v-model="sponsor_ein"
                                            label="Sponsor EIN"
                                            >    
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols=12 sm=6 md=6>
                                            <v-autocomplete
                                                v-model="template_selected"
                                                label="Select A Template"
                                                :items=agreementTemplateList
                                                item-text="template_name"
                                                item-value="template_id"
                                                outlined
                                                return-object
                                                hide-details
                                            >
                                            </v-autocomplete>
                                        </v-col>
                                     </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                color="primary"
                                text
                                @click="dialog = false"
                              >
                                Close
                              </v-btn>
                              <v-btn
                                color="primary"
                                text
                                @click="addAgreement(detail)"
                              >
                                Create Agreement
                              </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
  import AgreementQueue from '@/components/proposalcomps/AgreementQueue.vue';
  import { mapActions, mapGetters} from 'vuex';
  export default {
    data: () => ({
      dialog: false,
      confirm: false,
      sponsor_first_name: '',
      sponsor_last_name: '',
      sponsor_email: '',
      sponsor_address: '',
      sponsor_zip: '',
      sponsor_city: '',
      sponsor_state: '',
      sponsor_phone: '',
      sponsor_fax: '',
      sponsor_ein: '',
      
      template_selected: '',
      
      plan: null,
      
      planName: '',
      planYearBegin: null,
      planYearEnd: null,
  
    }),
    
    mounted(){
        this.template_selected = this.defaultAgreement
        
    },

    props: {
        detail: [Object],
        object: [Object],
        defaultAgreement: [Object],
    },
    
    methods: {
        ...mapActions(['getClient','updatePlanAgreementExecution', 'getPlanOpportunity', 'deleteAgreement']),
        addAgreement(detail){
            let agreement = {
              agreement: {
                 agreement_id: null,
                 plan_opportunity_id: this.object.plan_opportunity_id,
                 proposal_id:        detail.proposal_id,
                 client_id:          this.object.client_id,
                 sponsor_first_name: this.sponsor_first_name,
                 sponsor_last_name:  this.sponsor_last_name,
                 sponsor_email:      this.sponsor_email,
                 sponsor_address:    this.sponsor_address,
                 sponsor_zip:        this.sponsor_zip,
                 sponsor_city:       this.sponsor_city,
                 sponsor_state:      this.sponsor_state,
                 sponsor_phone:      this.sponsor_phone,
                 sponsor_fax:        this.sponsor_fax,
                 sponsor_ein:        this.sponsor_ein,
                 template_id:        this.template_selected.template_id,
                 date_time_reviewed: Date.now(),
                 plan_name:          this.planName,
                 plan_year_end:      this.planYearEnd,
                 plan_year_begin:    this.planYearBegin,
              },
             
            }
            this.updatePlanAgreementExecution(agreement)
            this.dialog=false;
        },
        
        editAgreement(id){
            console.log('Edit Agreement ID: '+id)
        },
        
        downloadAgreementPDF(id){
            console.log('Download Agreement Proposal ID: '+id)
        },
        getClientObj(){
            this.getPlanOpportunity(this.object.plan_opportunity_id)
            this.getClient(this.object.client_id)
        }
    },
    
    computed: {
        ...mapGetters({
          client: 'readClient',
          contact: 'readContact',
          planOpp: 'planOpportunity',
          globalContext: 'globalContext',
        }),
        
        agreementTemplateList(){
            return this.globalContext.listsContext.agreementTemplates[this.object.duration].defined.concat(this.globalContext.listsContext.agreementTemplates[this.object.duration].starter)
        },
    },
    
    watch: {
      client(){
        if(this.client.client_id !== null){
          this.plan = this.planOpp;
          
          this.planName = this.client.client_name;
          this.sponsor_first_name= this.contact.first_name;
          this.sponsor_last_name= this.contact.last_name;
          this.sponsor_email= this.contact.email;
          this.sponsor_address= this.client.company_address;
          this.sponsor_zip= this.client.company_zip;
          this.sponsor_city= this.client.company_city;
          this.sponsor_state= this.client.company_state;
          this.sponsor_phone= this.client.company_phone;
          this.sponsor_fax= this.client.company_fax;
        }
      },
    },
    components: {
       AgreementQueue
    }
  };
</script>

<style type="text/css" scoped>
    .agreement_line_item {
        background-color: #E0E0E0;
        border-radius: 10px;
    }
</style>